export const USER_INPUT_GET_INDICATOR_INPUT__ALL_TYPE_REQUEST = 'USER_INPUT_GET_INDICATOR_INPUT__ALL_TYPE_REQUEST';
export const USER_INPUT_GET_INDICATOR_INPUT__ALL_TYPE_SUCCESS = 'USER_INPUT_GET_INDICATOR_INPUT__ALL_TYPE_SUCCESS';
export const USER_INPUT_GET_INDICATOR_INPUT__ALL_TYPE_FAIL = 'USER_INPUT_GET_INDICATOR_INPUT__ALL_TYPE_FAIL';


